export default __webpack_public_path__ + "static/media/kubernetes.e1a6df3b.svg";